module.exports = __webpack_public_path__ + "img/btn.b8fa5331.png";